import { Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';
@Component({
  selector: 'app-navigation-secondary-about',
  template: `
    <app-bar
      i18n-title="Secondary navigation about us bar title"
      title="About Us"
      link="/about"
      flTrackingSection="SubnavAbout">
      <app-bar-item link="/about"
        [exactLink]="true"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Overview"
      >
        Overview
      </app-bar-item>
      <app-bar-item link="/about/management"
        [exactLink]="true"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Team"
      >
        Team
      </app-bar-item>
      <app-bar-item link="/careers"
        [exactLink]="true"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Careers"
      >
        Careers
      </app-bar-item>
      <app-bar-item link="/about/press"
        [exactLink]="true"
        flTrackingLabel="Press"
      >
        Press
      </app-bar-item>
      <app-bar-item link="/about/media"
        [exactLink]="true"
        flTrackingLabel="News"
      >
        News
      </app-bar-item>
      <app-bar-item link="/about/awards"
        [exactLink]="true"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Awards"
      >
        Awards
      </app-bar-item>
      <app-bar-item link="/about/quotes"
        [exactLink]="true"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Quotes"
      >
        Quotes
      </app-bar-item>
      <app-bar-item link="/investor"
        [exactLink]="true"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Investor"
      >
        Investor
      </app-bar-item>
      <app-bar-item link="/about/security"
        [exactLink]="true"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Security"
      >
        Security
      </app-bar-item>
      <app-bar-item link="/contact"
        [exactLink]="true"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="ContactUs"
      >
        Contact Us
      </app-bar-item>
      <fl-button [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation about us bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryAboutComponent {
  ButtonColor = ButtonColor;
}
